// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__1RWXI","form":"styles_form__fP6T2"};